import { Typography } from 'components/typography/typography-component';
import React from 'react';

export default function ReactSquadCTA() {
  return (
    <div className="mt-24 bg-black pb-20 pt-16">
      <div className="justify-center text-center">
        <Typography
          variant="h1"
          className="font-GTWalsheimPro text-[48px] leading-none text-white md:text-[85px]"
        >
          Ready to get <br />
          <span className="bg-gradient-to-r from-[#FF8F00] to-[#FFC400] bg-clip-text text-fill-transparent">
            Started
          </span>
          ?
        </Typography>
      </div>

      <Typography
        variant="paragraph"
        className="mb-12 mt-4 px-4 text-center text-white"
      >
        Get the Engineering Power your Startup deserves, up and running
        <br /> in &lt;7 days.
      </Typography>
      <div className="flex justify-center">
        <a
          target="_blank"
          href="https://calendly.com/nikolas-earlynode/reactsquad-io-chat-via-boteatbrain?month=2023-07"
          className="flex flex-col justify-center self-center rounded-3xl bg-white px-12 py-2 font-semibold  text-black"
          rel="noreferrer"
        >
          {"Let's Talk"}
        </a>
      </div>
    </div>
  );
}
